import { Trans, useTranslation } from '@lyearn/i18n';
import { TypographyWithTooltip } from '@lyearn/molecules';
import { cn } from '@lyearn/style';
import { Divider, Stack, Typography } from '@lyearn/ui';
import { Modal } from '@/components/Modals';
import VirtualizedList from '@/components/VirtualizedList';
import RESOURCE_TYPE_LABEL_CONFIG from '@/modules/content/config/label';
import renderImage from '@/modules/content/utils/renderImage';
import { ContentEntity, ResourceTypeEnum } from '@/types/schema';

import { QuestionEditorParentContentsFragment } from '../../../../../../graphql/fragments/generated/QuestionEditorParentContents';
import { ImpactedContentModalProps } from './types';

const ImpactedContentModal: React.FC<ImpactedContentModalProps> = (props) => {
  const { title, onClose, parentContents, fetchMore, action } = props;
  const { t } = useTranslation();

  const itemContent = (index: number, item: QuestionEditorParentContentsFragment) => {
    const content = item as ContentEntity;
    return (
      <Stack
        className={cn('px-24', { 'pb-24': index === parentContents.length - 1 })}
        direction="col">
        <Stack alignItems="center" className="p-12" gapX={12}>
          {renderImage({
            image: content.cover?.url,
            width: 48,
            height: 48,
            contentName: content.name,
            className: 'w-48 h-48 object-cover',
          })}
          <Stack className="overflow-hidden" direction="col" gapY={2}>
            <TypographyWithTooltip numberOfLines={1} variant="body-short-01">
              {content.name}
            </TypographyWithTooltip>
            <Typography color="text-text-secondary" variant="body-short-02">
              {t(RESOURCE_TYPE_LABEL_CONFIG[content.type as ResourceTypeEnum].title)}
            </Typography>
          </Stack>
        </Stack>
        {index !== parentContents.length - 1 ? <Divider /> : null}
      </Stack>
    );
  };

  return (
    <Modal
      action={action}
      header={{
        title,
        description: (
          <Trans i18nKey="QuizCreator:EditingInfo.ImpactedContentDescription" variant="label-01" />
        ),
      }}
      onClose={onClose}>
      <VirtualizedList
        className="flex flex-1"
        contentContainerClassName="pb-24"
        data={parentContents}
        endReached={fetchMore}
        itemContent={itemContent}
      />
    </Modal>
  );
};

export default ImpactedContentModal;
